import { ReactNode, createContext, useContext, useReducer } from "react";

import { InitialContext } from "../types/state/context";
import {
  ItemNumberSearchesActionTypes,
  ItemNumberSearchesState,
} from "states/item-number-searches/data.type";
import { ItemNumberSearchesReducer } from "states/item-number-searches";

type Context = InitialContext<ItemNumberSearchesState, ItemNumberSearchesActionTypes>;

export const ItemNumberSearchesContext = createContext<Context>({} as Context);

export function ItemNumberSearchesProvider({ children }: { children: ReactNode }) {
  const [state, dispatch] = useReducer(
    ItemNumberSearchesReducer.reducer,
    ItemNumberSearchesReducer.initialState,
  );

  return (
    <ItemNumberSearchesContext.Provider value={{ state, dispatch }}>
      {children}
    </ItemNumberSearchesContext.Provider>
  );
}

export const useItemNumberSearchesStore = () => useContext(ItemNumberSearchesContext);
